import { ArrowPathIcon } from '@heroicons/react/24/outline';
import { useImportsManagement } from './useImportsManagement';
import { ImportsList } from './ImportsList';
import { ImportForm } from './ImportForm';
import { ImportPreview } from './ImportPreview';

const ImportsManagement = () => {
  const state = useImportsManagement();

  if (state.loading && state.definitions.length === 0) {
    return (
      <div className="flex items-center justify-center h-64">
        <ArrowPathIcon className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6">
      <input
        ref={state.runImportInputRef}
        type="file"
        accept=".xlsx,.xls,.csv,.txt,.json,.xml,.dat"
        onChange={state.handleRunImportFileSelect}
        className="hidden"
        data-testid="run-import-file-input"
      />
      <ImportPreview state={state} />
      <ImportsList state={state} />
      <ImportForm state={state} />
    </div>
  );
};

export default ImportsManagement;
